export default __webpack_public_path__ + "static/media/front-desk-01.9e974e0c.jpg";